export function mentionLabel(mention) {
  if (mention.kind === "document_arrival") return "A new document";
  const sender = mention.sender;
  if (!sender) return "A former teammate";
  return `${sender.firstName || ""} ${sender.lastName || ""}`.trim() || "A teammate";
}

export function mentionVerb(mention) {
  const group = mention.viaGroup?.name;
  if (mention.kind === "assignment") return group ? `assigned ${group} to` : "assigned you to";
  if (mention.kind === "document_arrival") return "arrived on";
  return group ? `mentioned ${group} on` : "mentioned you on";
}
